let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bIgd2")).then(() => parcelRequire('eroYZ'));